export const BOOKING_CLASS_LISTING = 'book-class';
export const FREE_INQUIRY_ALIAS = 'default-inquiry/release-1';
export const BLOCK_BOOKING_ALIAS = 'block-booking/release-1';
export const FREE_TRIAL_PROCESS_ALIAS = 'free-trial/release-1';
